/**
 * @generated SignedSource<<46321c3d209f9b1c28334ac810056e8c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type SlackChannelTypeaheadChannelInfoQuery$variables = {
  channelId: string;
};
export type SlackChannelTypeaheadChannelInfoQuery$data = {
  readonly slackChannelInfo: {
    readonly id: string;
    readonly isMember: boolean;
    readonly isPrivate: boolean;
    readonly name: string;
  } | null | undefined;
};
export type SlackChannelTypeaheadChannelInfoQuery = {
  response: SlackChannelTypeaheadChannelInfoQuery$data;
  variables: SlackChannelTypeaheadChannelInfoQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "channelId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "slackChannelId",
        "variableName": "channelId"
      }
    ],
    "concreteType": "GraphQLSlackChannel",
    "kind": "LinkedField",
    "name": "slackChannelInfo",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isMember",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isPrivate",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SlackChannelTypeaheadChannelInfoQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SlackChannelTypeaheadChannelInfoQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "3b44adfb59899b06e211a1b0aa15afd1",
    "id": null,
    "metadata": {},
    "name": "SlackChannelTypeaheadChannelInfoQuery",
    "operationKind": "query",
    "text": "query SlackChannelTypeaheadChannelInfoQuery(\n  $channelId: String!\n) {\n  slackChannelInfo(slackChannelId: $channelId) {\n    id\n    name\n    isMember\n    isPrivate\n  }\n}\n"
  }
};
})();

(node as any).hash = "898e3148c5c1b3ffdd4d4d777657de1f";

export default node;
